// BaseFormComponent.js
import { ErrorMessage, Field } from "formik";
import React from "react";

const BaseFormComponent = ({
  label,
  name,
  type,
  placeholder,
  required,
  max,
  handleSpecialCharacters,
  errorMessage,
}) => {
  return (
    <div className="col-md-4">
      <div className="form-group">
        <label className="form-label">
          {label}
          {required && <span style={{ color: "#EC1117" }}> *</span>}
        </label>
        <Field
          type={type}
          id={name}
          {...(max ? { maxLength: max } : {})}
          name={name}
          onKeyPress={handleSpecialCharacters}
          className="form-control"
          placeholder={placeholder}
        />
        <ErrorMessage
          className="form-text text-danger"
          name={name}
          component="span"
        />
      </div>
    </div>
  );
};

export default BaseFormComponent;
